import {
  compose, hoistStatics,
} from 'recompose';
import Radio from './radio';

const enhance = compose(
);
export default hoistStatics(enhance)(Radio);
